import { render, staticRenderFns } from "./BlackFridayAlert.vue?vue&type=template&id=911214e0&scoped=true&"
import script from "./BlackFridayAlert.vue?vue&type=script&lang=js&"
export * from "./BlackFridayAlert.vue?vue&type=script&lang=js&"
import style0 from "./BlackFridayAlert.vue?vue&type=style&index=0&id=911214e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "911214e0",
  null
  
)

export default component.exports